import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import { styledOmitPropsOptions } from "../../theme/styled.helpers";
import { TopRow } from "../TopRow";
import { BodyTextM } from "../Typography";

export const PaymentHeaderGrid = styled(Grid)(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(7),
    [theme.breakpoints.down("md")]: {
        flexDirection: "column",
        gap: theme.spacing(4),
    },
}));

export const PaymentHeaderTopRow = styled(TopRow)({});

export const PaymentHeaderBodyTextM = styled(
    BodyTextM,
    styledOmitPropsOptions,
)<{
    $bold?: boolean;
    $isHighlighted?: boolean;
}>(({ $bold, $isHighlighted, theme }) => ({
    textAlign: "left",
    display: "block",
    marginTop: theme.spacing(2),
    fontWeight: $bold ? "bold" : "normal",
    color: $isHighlighted ? theme.palette.primary.dark : theme.palette.common.black,
}));
